/**
 * @param PaymentAccordionItem Base widget for extending
 * @returns Zero Payment Accordion Item widget
 */
function PaymentAccordionItemZEROPAYMENTClassCreator(
    PaymentAccordionItem: import('widgets/checkout/PaymentAccordionItem').TPaymentAccordionItem
) {
    /**
     * @category widgets
     * @subcategory checkout
     * @class PaymentAccordionItemZEROPAYMENT
     * @augments PaymentAccordionItem
     * @classdesc Represents PaymentAccordionItemZEROPAYMENT component with the next features:
     * 1. Handles payment tab submit
     * 2. Validates payment tab child elements
     *
     * @example <caption>Example of PaymentAccordionItemZEROPAYMENT widget usage</caption>
     * <section
     *     data-widget="paymentAccordionItem${paymentOption.ID}"
     *     data-widget-event-closeallitems="closeItems"
     *     data-widget-event-accordionitemupdate="updateFocusedItem"
     *     data-expanded="true"
     *     data-method-id="${paymentOption.ID}"
     *     data-method-name="${paymentOption.name}"
     *     data-widget-event-openpanel="hidePaymentError"
     *     data-tau-payment-id="${paymentOption.ID}"
     *     class="b-payment_accordion-item"
     * >
     *     <isinclude template="checkout/billing/paymentOptions/paymentTitle_ZERO_PAYMENT" />
     *     <div
     *         id="payment-details-${paymentOption.ID}"
     *         data-ref="accordionItemPanel"
     *         class="b-payment_accordion-content"
     *         data-tau="payment-details-${paymentOption.ID}"
     *     >
     *         <div class="b-payment_accordion-content_inner" data-ref="accordionItemPanelInner">
     *             <p class="b-payment_accordion-label"><isprint value="${paymentOption.description}" encoding="off" /></p>
     *             <p><isprint value="${Resource.msg('billing.fieldset.email', 'checkout', null)}" /></p>
     *             <p><strong>${pdict.order.orderEmail || pdict.forms.billingForm.contactInfoFields.email.htmlValue}</strong></p>
     *         </div>
     *     </div>
     * </section>
     */
    class PaymentAccordionItemZEROPAYMENT extends PaymentAccordionItem {
        /**
         * @description Handles zero payment tab submit
         * @returns result
         */
        process(): Promise<[]> {
            return Promise.resolve([]);
        }

        /**
         * @description Validates zero payment tab child elements.
         * @returns validation result
         */
        isChildrenValid(): boolean {
            return true;
        }
    }

    return PaymentAccordionItemZEROPAYMENT;
}

export type TPaymentAccordionItemZEROPAYMENT = ReturnType<typeof PaymentAccordionItemZEROPAYMENTClassCreator>;

export type TPaymentAccordionItemZEROPAYMENTInstance = InstanceType<TPaymentAccordionItemZEROPAYMENT>;

export default PaymentAccordionItemZEROPAYMENTClassCreator;
